import { Outlet } from "react-router-dom";
import Footer from "../../commons/footer/footer";
import Header from "../../commons/header/header";
import ScrollTop from "../../commons/scrollTop/scrollTop";

/**
 * Layout principal: header fijo, contenido de la ruta (Outlet),
 * footer y botón "volver arriba".
 */
const MainLayout = () => {
  return (
    <>
      <Header />
      <main>
        <Outlet />
      </main>
      <Footer />
      <ScrollTop />
    </>
  );
};

export default MainLayout;
